// Shows its button only near the bottom of the page; the --scroll-top command returns the visitor to the top.
class SBackToTop extends HTMLElement {
  #ac = null;
  #raf = null;

  connectedCallback() {
    this.#ac = new AbortController();
    const opts = { signal: this.#ac.signal, passive: true };
    window.addEventListener('scroll', () => this.#schedule(), opts);
    window.addEventListener('resize', () => this.#schedule(), opts);
    this.addEventListener('command', (event) => {
      if (event.command !== '--scroll-top') return;
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
      document.getElementById('main-content')?.focus({ preventScroll: true });
    }, { signal: this.#ac.signal });
    this.#update();
  }

  disconnectedCallback() {
    this.#ac?.abort();
    if (this.#raf) cancelAnimationFrame(this.#raf);
  }

  #schedule() {
    if (this.#raf) return;
    this.#raf = requestAnimationFrame(() => {
      this.#raf = null;
      this.#update();
    });
  }

  #update() {
    const threshold = Number(this.dataset.threshold || 400);
    const distanceFromBottom = document.documentElement.scrollHeight - (window.scrollY + window.innerHeight);
    const visible = window.scrollY > 0 && distanceFromBottom <= threshold;
    this.toggleAttribute('data-visible', visible);
    this.inert = !visible;
  }
}

if (!customElements.get('s-back-to-top')) customElements.define('s-back-to-top', SBackToTop);
